import React from 'react'
import { Paragraph } from '../../publication/Paragraph/Paragraph'
import { Subhead } from '../../typography/Subhead/Subhead'
import {
    StyledPodcastLogoLink,
    StyledPodcastLogos,
} from '../TheWestLive/TheWestLivePlayerPage/TheWestLivePlayerPage.styled'

const listnrPodcastBadge = require('./assets/listnrPodcastBadge.png')
const applePodcastBadge = require('./assets/applePodcastBadge.jpg')
const spotifyPodcastBadge = require('../TheWestLive/TheWestLivePlayerPage/assets/spotifypodcast.png')
const youtubePodcastBadge = require('./assets/youtubePodcastBadge.png')
const youtubeMusicPodcastBadge = require('./assets/youtubeMusicPodcastBadge.png')

export interface PodcastSubscribeProps {
    title: string
    description?: string
    apple?: string
    spotify?: string
    youtube?: string
    youtubeMusic?: string
    listnr?: string
    onEvent: (event: any) => void
}

export const PodcastSubscribe: React.FC<PodcastSubscribeProps> = (props) => {
    return (
        <>
            <Subhead
                idAttribute="podcast"
                tag="h2"
                text={`Subscribe to ${props.title}`}
                onEvent={props.onEvent}
            />
            <Paragraph
                text={
                    props.description ??
                    'Never miss an episode by subscribing to the podcast'
                }
                onEvent={props.onEvent}
            />
            {props.listnr && (
                <StyledPodcastLogoLink to={props.listnr} rel="noopener">
                    <StyledPodcastLogos
                        src={listnrPodcastBadge}
                        alt={`Listen to ${props.title} on Listnr`}
                        width="105"
                        height="33"
                    />
                </StyledPodcastLogoLink>
            )}
            {props.apple && (
                <StyledPodcastLogoLink to={props.apple} rel="noopener">
                    <StyledPodcastLogos
                        src={applePodcastBadge}
                        alt={`Listen to ${props.title} on Apple Podcasts`}
                        width="105"
                        height="33"
                    />
                </StyledPodcastLogoLink>
            )}
            {props.spotify && (
                <StyledPodcastLogoLink to={props.spotify} rel="noopener">
                    <StyledPodcastLogos
                        src={spotifyPodcastBadge}
                        alt={`Listen to ${props.title} on Spotify`}
                        width="136"
                        height="33"
                    />
                </StyledPodcastLogoLink>
            )}
            {props.youtube && (
                <StyledPodcastLogoLink to={props.youtube} rel="noopener">
                    <StyledPodcastLogos
                        src={youtubePodcastBadge}
                        alt={`Listen to ${props.title} on YouTube`}
                        width="102"
                        height="33"
                    />
                </StyledPodcastLogoLink>
            )}
            {props.youtubeMusic && (
                <StyledPodcastLogoLink to={props.youtubeMusic} rel="noopener">
                    <StyledPodcastLogos
                        src={youtubeMusicPodcastBadge}
                        alt={`Listen to ${props.title} on YouTube Music`}
                        width="123"
                        height="33"
                    />
                </StyledPodcastLogoLink>
            )}
            <div id="anchor"></div>
        </>
    )
}
